import { useState } from 'react';
import { format } from 'date-fns';
import { asyncApiCall } from '../../api';
import { exportFinalizedVouchersApi } from '../apiOuigoRefunds';
import { downloadCsvFile } from '../utils';

const exportFinalizedVouchersRequest = (parameters) =>
	asyncApiCall(exportFinalizedVouchersApi, parameters);

const useArchiveCsvExport = ({
	appliedFromDate,
	appliedToDate,
	exportFinalizedVouchers = exportFinalizedVouchersRequest,
	sortBy,
}) => {
	const [isDownloading, setIsDownloading] = useState(false);
	const [hasError, setHasError] = useState(false);

	const download = async () => {
		if (isDownloading) {
			return;
		}

		setIsDownloading(true);
		setHasError(false);

		try {
			const csvFile = await exportFinalizedVouchers({
				startDate: appliedFromDate
					? format(appliedFromDate, 'yyyy-MM-dd')
					: undefined,
				endDate: appliedToDate
					? format(appliedToDate, 'yyyy-MM-dd')
					: undefined,
				sortBy,
			});

			downloadCsvFile(csvFile);
		} catch {
			setHasError(true);
		} finally {
			setIsDownloading(false);
		}
	};

	return {
		clearError: () => setHasError(false),
		download,
		hasError,
		isDownloading,
	};
};

export default useArchiveCsvExport;
